import React, { useEffect } from 'react';
import { useAppDispatch } from 'app/store';
import { setHeaderAction, setHeaderTitle } from 'features/ui/model/uiSlice';
import { DownloadsCodesTable } from 'widgets/downloads';

export const DownloadsTablesCodePage = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setHeaderTitle('Призы - Таблицы кодов'));

    return () => {
      dispatch(setHeaderAction(null));
    };
  }, []);

  return <DownloadsCodesTable />;
};
